import { Skeleton } from "antd";
import { createStyles } from "antd-style";

const useStyles = createStyles(({ css }) => ({
  placeHolder: css`
    height: 20px;
    opacity: 80%;
  `,
}));

export function LineLoader() {
  const { styles } = useStyles();

  return <Skeleton.Input className={styles.placeHolder} active size="default" />;
}
